export default __webpack_public_path__ + "static/media/duck.5ab2ad04.png";